import React from 'react';
import { CornerDownLeft } from 'lucide-react';
import { cn } from '../../lib/utils';

export function MessageReplyQuote({
  replyTo,
  onNavigate,
  className,
}) {
  if (!replyTo) return null;

  const senderName = replyTo.senderName || (replyTo.sender_id ? 'Student' : 'Përdorues');
  const previewText = replyTo.content || (replyTo.fileType ? `[Skedar: ${replyTo.fileType}]` : 'Mesazh');

  return (
    <div
      onClick={onNavigate ? () => onNavigate(replyTo.id) : undefined}
      className={cn(
        'mb-2 min-w-0 rounded-xl border-l-[3px] border-[#DD0000] bg-amber-50/70 dark:bg-amber-950/20 px-2.5 py-1.5 text-left select-none transition-opacity',
        onNavigate && 'cursor-pointer hover:opacity-90',
        className
      )}
    >
      <div className="flex min-w-0 items-center gap-1">
        <CornerDownLeft className="h-3 w-3 shrink-0 text-[#DD0000]" aria-hidden />
        <span className="truncate text-xs font-bold text-[#DD0000]">{senderName}</span>
      </div>
      <p className="mt-0.5 line-clamp-2 break-words text-xs leading-snug text-zinc-600 dark:text-zinc-300">
        {previewText}
      </p>
    </div>
  );
}

export default MessageReplyQuote;
